export enum DraggableItemType {
  CoreProperty = "CoreProperty"
}